import { graphql } from "gatsby";
import React from "react";
import Layout from "./Layout";
import "../styles/PostPage.css";
import ResultDisplay from "./ResultDisplay";
import Button from "./Button";
import { navigate } from "gatsby";
import LastPosts from "./LastPosts";
import Seo from "./Seo";

const PostPage = (props) => {
  const prevPage = props.pageContext.previous
    ? props.pageContext.previous
    : null;
  const nextPage = props.pageContext.next ? props.pageContext.next : null;
  const navigatepreviousPage = () => {
    navigate(`/${prevPage}`);
  };
  const navigateNextPage = () => {
    navigate(`/${nextPage}`);
  };

  const navigationButtonsDisplay = () => {
    if (prevPage) {
      if (nextPage) {
        return (
          <>
            <div className="button-group">
              <Button
                label="← Précédent"
                onClick={navigatepreviousPage}
                style={{ width: "30%" }}
              />
              <Button
                label="Suivant →"
                onClick={navigateNextPage}
                style={{ width: "30%" }}
              />
            </div>
          </>
        );
      }
      return (
        <>
          <div className="button-group">
            <Button
              label="← Précédent"
              onClick={navigatepreviousPage}
              style={{ width: "30%" }}
            />
            <Button
              disabled
              className="disabled"
              label="Suivant →"
              onClick={navigateNextPage}
              style={{ width: "30%" }}
            />
          </div>
        </>
      );
    } else if (nextPage) {
      return (
        <>
          <div className="button-group">
            <Button
              disabled
              className="disabled"
              label="← Précédent"
              onClick={navigatepreviousPage}
              style={{ width: "30%" }}
            />
            <Button
              label="Suivant →"
              onClick={navigateNextPage}
              style={{ width: "30%" }}
            />
          </div>
        </>
      );
    } else {
      return <></>;
    }
  };

  return (
    <Layout>
      <div className="banner">
        <h1>{props.data.mdx.frontmatter.title}</h1>
      </div>
      <div className="flexContainer">
        <ResultDisplay result={props} />
      </div>
      {navigationButtonsDisplay()}
      <LastPosts />
    </Layout>
  );
};
export const getSlug = graphql`
  query OneBlogQuery($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      excerpt(pruneLength: 150)
      frontmatter {
        cover
        coverAlt
        tags
        title
        blogger
        bloggerpitch
        qu_id
      }
      imgFilePNG: imgFile {
        childImageSharp {
          gatsbyImageData(formats: PNG, height: 250, width: 250)
        }
      }
      imgFileWEBP: imgFile {
        childImageSharp {
          gatsbyImageData(formats: WEBP, height: 250, width: 250)
        }
      }

      imgAvatar {
        childImageSharp {
          gatsbyImageData(height: 100, width: 100)
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`;

export const Head = (props) => {
  console.log(
    props.data.mdx.imgFileWEBP.childImageSharp.gatsbyImageData.images
  );
  const canonicalUrl = `${props.data.site.siteMetadata.siteUrl}${props.location.pathname}`;
  return (
    <Seo
      title={`${props.data.mdx.frontmatter.title}`}
      description={props.data.mdx.excerpt}
      pathname={`${props.location.pathname}`}
      image={
        props.data.mdx.imgFileWEBP.childImageSharp.gatsbyImageData.images
          .fallback.src
      }
    >
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "@id": props.location.pathname,
          headline: props.data.mdx.frontmatter.title,
          name: props.data.mdx.frontmatter.title,
          description: props.data.mdx.excerpt,
          datePublished: "2023-03-07",
          dateModified: "2023-03-07",
          image: [
            props.data.mdx.imgFileWEBP.childImageSharp.gatsbyImageData.images
              .fallback.src,
          ],
          author: [
            {
              "@type": "Person",
              name: props.data.mdx.frontmatter.blogger,
            },
          ],
          mainEntityOfPage: {
            "@type": "webPage",
            id: props.location.href,
          },
        })}
      </script>
      <link rel="canonical" href={canonicalUrl} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta
        property="twitter:site"
        content={props.data.site.siteMetadata.siteUrl}
      />
      <meta
        property="twitter:title"
        content={props.data.mdx.frontmatter.title}
      />
      <meta
        property="twitter:description"
        content={props.data.mdx.frontmatter.excerpt}
      />
      <meta
        name="twitter:image:src"
        content={`${props.data.site.siteMetadata.siteUrl}${props.data.mdx.imgFilePNG.childImageSharp.gatsbyImageData.images.fallback.src}`}
      />
      <meta property="twitter:image:width" content="250" />
      <meta property="twitter:image:height" content="250" />
    </Seo>
  );
};

export default PostPage;
